import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "./context/StoreContext";

import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ProductPage from "./pages/ProductPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderResultPage from "./pages/OrderResultPage";
import SimulatedPayPage from "./pages/SimulatedPayPage";
import OriginalityPage from "./pages/OriginalityPage";
import LoginPage from "./pages/LoginPage";
import AccountPage from "./pages/AccountPage";

import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminProducts from "./admin/AdminProducts";
import AdminProductEdit from "./admin/AdminProductEdit";
import AdminCategories from "./admin/AdminCategories";
import AdminOrders from "./admin/AdminOrders";
import AdminStock from "./admin/AdminStock";
import AdminAuctions from "./admin/AdminAuctions";
import AdminCustomers from "./admin/AdminCustomers";
import AdminCoupons from "./admin/AdminCoupons";
import AdminContent from "./admin/AdminContent";
import AdminDragons from "./admin/AdminDragons";
import AdminSettings from "./admin/AdminSettings";
import AdminLogs from "./admin/AdminLogs";

function App() {
  return (
    <div className="App">
      <StoreProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/categoria/:slug" element={<CategoryPage />} />
            <Route path="/produto/:slug" element={<ProductPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/pedido/:id" element={<OrderResultPage />} />
            <Route path="/pagamento-simulado/:id" element={<SimulatedPayPage />} />
            <Route path="/autenticidade" element={<OriginalityPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/conta" element={<AccountPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="produtos" element={<AdminProducts />} />
              <Route path="produtos/novo" element={<AdminProductEdit />} />
              <Route path="produtos/:id" element={<AdminProductEdit />} />
              <Route path="categorias" element={<AdminCategories />} />
              <Route path="pedidos" element={<AdminOrders />} />
              <Route path="estoque" element={<AdminStock />} />
              <Route path="leiloes" element={<AdminAuctions />} />
              <Route path="clientes" element={<AdminCustomers />} />
              <Route path="cupons" element={<AdminCoupons />} />
              <Route path="conteudo" element={<AdminContent />} />
              <Route path="dragoes" element={<AdminDragons />} />
              <Route path="logs" element={<AdminLogs />} />
              <Route path="configuracoes" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#141414", border: "1px solid rgba(212,175,55,0.3)", color: "#fff" } }} />
      </StoreProvider>
    </div>
  );
}

export default App;
